
<template>
  <div class="bg">

    <div class="content-box">

      <span class="word3">关于捡漏</span>
      <ol start="1">
        <li>超值捡漏出售的小号均为官方回收号，所有小号均以该小号实际支付总额的1折出售；</li>
        <li>有几率买到极品号，也有几率买到被封的废号等情况；</li>
        <li>显示区服为玩家提供，不保证真实性，游戏内角色情况未知，只保证小号真实充值准确；</li>
        <li>购买后小号将直接转入您的账号下，登录游戏后选择对应小号即可</li>
        <li>购买的小号不支持再次回收,转游转区等操作；</li>
        <li>购买前请下载游戏确认系统是否支持进入游戏</li>
        <li>特价商品除特殊情况外无法售后，购买后且不支持退款，请谨慎购买；</li>
        <li>如有任何疑问请联系客服咨询。</li>
      </ol>
      <span>注意：未成年用户将无法使用该功能</span>
    </div>
  </div>
</template>
  
<style scoped="scoped" lang="less">
.bg {
  height: 100vh;
  padding-top: 80px;
  background-color: #f7f8fa;
  color: #000;

  .content-box {
    padding: 12px;
    border-radius: 10px;

    h3 {
      font-size: 37px;
      font-family: PingFang SC;
      font-weight: 650;
      color: #333333;
      margin-top: 20px;
    }

    img {
      height: 97px;
      object-fit: fill;
      width: 100%;
      margin-top: 20px;
    }

    ol {
      margin-top: 10px;
      padding: 0 24px;

      li {
        list-style-type: decimal;
        list-style-position: inside;
        font-size: 24px;
        margin-top: 10px;

        &:nth-of-type(6) {
          color: #FF6666;
        }
      }
    }

    .word3 {
      font-size: 28px;
      font-weight: bold;
      margin-left: 32px;
    }

    span:nth-of-type(2) {
      font-size: 28px;
      margin-left: 20px;
    }
  }
}

</style>